import { api } from '~/services/api';
import { AxiosError } from 'axios';
import ICustomAxiosRequestConfig from '~/services/custom/ICustomAxiosRequestConfig';

type SettingsParams = {
  unit_id: string;
};

export type SettingsProps = {
  version: string[];
};

type GetSettingsProps = {
  data?: SettingsProps;
  status?: number;
  message?: string;
};

export const getSettings = async (
  params?: SettingsParams,
  serverSide?: { serverSide: boolean }
): Promise<GetSettingsProps> => {
  try {
    const { unit_id } = params as SettingsParams;
    const { data, status } = await api.get(
      `/line/v1/units/${unit_id}/settings`,
      {
        serverSide,
      } as ICustomAxiosRequestConfig
    );

    return {
      data: {
        ...data.data,
        ...((data.data.version || null) !== null &&
        typeof data.data.version === 'string'
          ? {
              version: JSON.parse(
                Buffer.from(data.data.version, 'base64').toString('utf-8')
              ),
            }
          : { version: [] }),
      },
      status,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      message: (error.response?.data as any).message,
      status: error.response?.status,
    };
  }
};
